module.exports = __webpack_public_path__ + "files/40c8ed303352751f119246649493f3c3.png";